import React, { useState } from "react";
import { Box, Button, Grid, Link, TextField, Typography } from "@mui/material";
import GenericPicker from "../../../components/utilities/GenericPicker";
import ModalLoadingFull from "../../../components/modals/ModalLoadingFull";
import ListResponsive from "../../../components/other/ListResponsive";

import moment from "moment";
import "moment-timezone";
import { postNotification } from "../../../components/utilities/Notifications";
import {
  deleteData,
  postData,
} from "../../../components/utilities/UtilityFunctions";

export default function StoreOrderNotes(props) {
  const { isAdmin, transaction, setTransaction } = props;
  const [newNote, setNewNote] = useState({ type: "Private Note", note: "" });
  const [processing, setProcessing] = useState(false);
  return (
    <>
      <Typography variant="h4" gutterBottom>
        Notes
      </Typography>

      {isAdmin === true && (
        <Grid container sx={{ width: "100%" }}>
          <Grid item xs={12}>
            <TextField
              name="note"
              label="Add Note"
              value={newNote.note}
              variant="outlined"
              fullWidth
              multiline
              rows={2}
              required
              margin="normal"
              onBlur={(e) => {
                setNewNote({
                  ...newNote,
                  [e.target.name]: e.target.value,
                });
              }}
              onChange={(e) => {
                setNewNote({
                  ...newNote,
                  [e.target.name]: e.target.value,
                });
              }}
            />
          </Grid>
          <Grid item xs={8}>
            <GenericPicker
              name="type"
              label="Note Type"
              value={newNote.type}
              handleChange={(e) => {
                setNewNote({
                  ...newNote,
                  [e.target.name]: e.target.value,
                });
              }}
              inclAny={false}
              required
              list={["Private Note", "Note to Customer"]}
              formControlSX={{
                height: "40px",
                "& .MuiSelect-select": {
                  p: "8px",
                },
              }}
            />
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              pl: 2,
              mb: 1,
              display: "flex",
              alignItems: "end",
            }}
          >
            <Button
              sx={{ height: "40px" }}
              disabled={
                !newNote.type ||
                !newNote.note ||
                newNote.type === "" ||
                newNote.note === ""
              }
              variant="outlined"
              type="button"
              fullWidth
              onClick={async () => {
                try {
                  setProcessing(true);

                  let updatedTransaction = await postData(
                    `/storetransactions/${transaction?.id}/note`,
                    {
                      body: newNote,
                    }
                  );
                  postNotification("success", "Note Saved");
                  setNewNote({ type: newNote.type, note: "" });
                  setTransaction(updatedTransaction);
                } catch (err) {
                  postNotification("error", err);
                  setProcessing(false);
                }

                setProcessing(false);
              }}
            >
              Add
            </Button>
          </Grid>
        </Grid>
      )}

      {transaction?.notes?.length > 0 && (
        <ListResponsive
          originalList={transaction?.notes || []}
          rowProps={{
            mapFunction: (row, index) => (
              <Grid
                key={index}
                item
                xs={12}
                sx={{
                  p: 1,
                  mb: 1,
                  border: "1px solid rgba(0, 0, 0, 0.12)",
                  borderRadius: 1,
                  boxShadow: 1,
                }}
              >
                <Box
                  sx={{
                    background:
                      row?.type === "Private Note" ? "#d7cad2" : "#EAFAEE",
                    padding: 2,
                    position: "relative",
                    "&::after": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      bottom: "-10px",
                      left: "20px",
                      width: 0,
                      height: 0,
                      borderWidth: "10px 10px 0 0",
                      borderStyle: "solid",
                      borderColor: `${
                        row?.type === "Private Note" ? "#d7cad2" : "#EAFAEE"
                      } transparent`,
                    },
                  }}
                >
                  <Typography variant="body1">
                    {row.note.split("\n").map((i, key) => {
                      return <Box key={key}>{i}</Box>;
                    })}
                  </Typography>
                </Box>

                <Box sx={{ mt: 1 }}>
                  <Typography variant="caption">
                    {moment(row?._created_at).format("MMMM Do, YYYY @ h:mma")}
                    {row?.user?.name ? `. ${row?.user?.name}` : ""}
                    {isAdmin === true && (
                      <>
                        {" "}
                        <Link
                          color="error"
                          sx={{
                            "&:hover": {
                              cursor: "pointer",
                            },
                          }}
                          onClick={async () => {
                            try {
                              setProcessing(true);

                              let updatedTransaction = await deleteData(
                                `/storetransactions/${transaction?.id}/note/${row?.id}`
                              );
                              postNotification("success", "Note Deleted");
                              setTransaction(updatedTransaction);
                            } catch (err) {
                              postNotification("error", err);
                              setProcessing(false);
                            }

                            setProcessing(false);
                          }}
                        >
                          Delete note
                        </Link>
                      </>
                    )}
                  </Typography>
                </Box>
              </Grid>
            ),
          }}
        />
      )}
      {processing && <ModalLoadingFull />}
    </>
  );
}
